"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _wrap = _interopRequireDefault(require("./wrap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Button = /*#__PURE__*/(0, _reactEmotion.default)('button', {
  target: "e1jb41s30"
})("border-radius:0;padding:0 1em 0 1em;font-weight:400;min-width:180px;height:", function (props) {
  return props.tall ? '60px' : '40px';
}, ";width:100%;color:", function (props) {
  return props.theme === 'dark' ? '#fff' : '#424A50';
}, ";opacity:", function (props) {
  return props.disabled ? '0.3' : '1';
}, ";pointer-events:", function (props) {
  return props.disabled ? 'none' : '';
}, ";background:", function (props) {
  return props.open ? props.theme === 'dark' ? '#111' : '#ededed' : 'transparent';
}, ";.material-icons{font-size:1.5em;color:#92999F;}&:focus{background:#e0e0e0;}&:hover,&:active{background:", function (props) {
  return props.theme === 'dark' ? '#111' : '#ededed';
}, ";}");
var Break = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e1jb41s31"
})("border-top-style:solid;border-top-width:1px;border-color:", function (props) {
  return props.theme === 'dark' ? '#000' : '#E0E3E4';
}, ";");

var Row = /*#__PURE__*/function (_React$Component) {
  _inherits(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row(props) {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      if (_this.state.open && _this.element && !_this.hasParent(e.target)) {
        _this.setState({
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!_this.hasChildren()) {
        if (_this.props.button.onClick && typeof _this.props.button.onClick === 'function') {
          _this.props.button.onClick(e);
        }

        if (_this.props.clickCloses) {
          _this.props.onClose(e);
        }
      } else {
        _this.setState(function (state) {
          return {
            open: !state.open
          };
        });
      }
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onMouseDown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onMouseDown, false);
    }
  }, {
    key: "hasParent",
    value: function hasParent(element) {
      if (!element.parentNode) return false;
      if (element.getAttribute('data-dropdown-submenu-wrap') === 'true') return true;
      return this.hasParent(element.parentNode);
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this.props.button.children && Array.isArray(this.props.button.children) && this.props.button.children.length;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var button = this.props.button;
      var AltWrap = Button.withComponent(button.wrapElementTag || 'button', {
        target: "e1jb41s32"
      });
      return /*#__PURE__*/_react.default.createElement(_reactTether.default, {
        attachment: "top left",
        targetAttachment: "top right",
        constraints: [{
          to: 'window',
          attachment: 'together',
          pin: true
        }]
      }, /*#__PURE__*/_react.default.createElement("li", {
        ref: function ref(_ref) {
          return _this2.element = _ref;
        },
        className: "p0 m0 list-style-none relative"
      }, /*#__PURE__*/_react.default.createElement(AltWrap, {
        theme: this.props.theme,
        tall: _typeof(button.text) === 'object' && button.text.title,
        onClick: this.onClick,
        "data-test-id": this.props.testID,
        disabled: button.disabled,
        open: this.state.open,
        className: 'cs-button flex items-center ' + (button.className || '')
      }, button.icon && /*#__PURE__*/_react.default.createElement("span", {
        className: /*#__PURE__*/(0, _emotion.css)("margin-right:.75em;") + " material-icons"
      }, button.icon), /*#__PURE__*/_react.default.createElement("div", {
        className: "mr3"
      }, _typeof(button.text) === 'object' && button.text.title ? /*#__PURE__*/_react.default.createElement("div", {
        className: /*#__PURE__*/(0, _emotion.css)("text-align:left;")
      }, /*#__PURE__*/_react.default.createElement("div", null, button.text.title), /*#__PURE__*/_react.default.createElement("div", {
        className: /*#__PURE__*/(0, _emotion.css)("margin-top:.5em;color:#92999F;font-size:12px;") + " block"
      }, button.text.description)) : button.text), this.hasChildren() && /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-auto flex justify-end items-center ml1"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons"
      }, "keyboard_arrow_right"))), button.breakAfter && /*#__PURE__*/_react.default.createElement(Break, {
        className: "my1",
        theme: this.props.theme
      })), this.state.open && /*#__PURE__*/_react.default.createElement(_wrap.default, {
        isSubmenu: true,
        theme: this.props.theme
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "py1 px0 m0"
      }, button.children.map(function (child, i) {
        return /*#__PURE__*/_react.default.createElement(Row, {
          theme: _this2.props.theme,
          testID: "".concat(_this2.props.testID, "-child-").concat(i),
          key: i,
          button: child,
          isSubmenu: true,
          clickCloses: _this2.props.clickCloses,
          onClose: function onClose() {
            return _this2.props.onClose();
          }
        });
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Row;
}(_react.default.Component);

Row.defaultProps = {
  theme: 'string'
};
Row.propTypes = {
  button: _propTypes.default.object.isRequired,
  onClose: _propTypes.default.func.isRequired,
  isSubmenu: _propTypes.default.bool.isRequired,
  testID: _propTypes.default.string.isRequired,
  theme: _propTypes.default.string
};
var _default = Row;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Button, "Button", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/row.js");
  reactHotLoader.register(Break, "Break", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/row.js");
  reactHotLoader.register(Row, "Row", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/row.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/row.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();